import debounce from 'lodash.debounce';

export const store = ({ amountForFreeShipping }) => ({
	/**
	 * Data
	 */
	data: {},

	/**
	 * Computed
	 */
	computed: {},

	/**
	 * categories
	 */
	categories: {
		registered: [],
		selected: '',
	},

	/**
	 * 
	 */
	tags: {
		show: false,
		registered: ['all'],
		selected: 'all',
	},

	/**
	 * Init
	 *
	 * @description initialize our store order app.
	 *
	 * @returns {void}
	 */
	init() {
		this.amountForFreeShipping = amountForFreeShipping;

		this.$watch('data', debounce(() => this.save(), 200));
		this.load();

		const urlHash = window.location.hash.substring(1);

		this.$nextTick(() => {
			if (this.categories.registered.includes(urlHash)) {
				this.categories.selected = urlHash;
			}
		});

		/*
		window.addEventListener('pagehide', () => {
			console.log('changing page context');
		});
		*/
	},

	/**
	 * Load
	 *
	 * @description load data from php function `rx_cart`.
	 *
	 * @returns {void}
	 */
	load() {
		/**
		 * This is all the functionality required to support an `?add`
		 * query parameter which can be passed in as `?add=62364:100,62376:100`.
		 * If an update is made via the query param, we then do not add
		 * the default WC cart contents.
		 */
		/*
		const addQueryParam = new URLSearchParams(window.location.search).get('add');
		let hasQueryParamUpdated = false;

		if (addQueryParam) {
			const items = addQueryParam.split(',');

			items.forEach((item) => {
				const [id, quantity] = item.split(':');

				$.ajax({
					type: 'POST',
					url: admin_url.ajax_url,
					data: { action: 'rx_get_product_data', data: id },
					dataType: 'json',
					success: (res) => {
						const { data } = res;
				
						if (data) {
							hasQueryParamUpdated = true;
							this.add(data, quantity);
						}
					},
					error: (error) => {
						console.log(error);
					}
				});
			});
		}

		if (hasQueryParamUpdated) {
			return;
		}
		*/

		/**
		 * Fallback/default behaviour of loading WC cart
		 */
		$.ajax({
			type: 'POST',
			url: admin_url.ajax_url,
			data: { action: 'rx_cart' },
			dataType: 'json',
			success: (res) => {
				const { data } = res;
		
				if (data) {
					this.data = data;
				}
			},
			error: (error) => {
				console.log(error);
			}
		});
	},

	/**
	 * Save
	 *
	 * @description when data updates, set local storage and invoke `rx_store` fn.
	 * 
	 * @returns {void}
	 */
	save() {
		if (this.data === false) {
			return;
		}

		$.ajax({
			type: 'POST',
			url: admin_url.ajax_url,
			data: { action: 'rx_store', data: this.data },
			dataType: 'json',
			success: (res) => {
				console.log({res});
				// $('#mini-cart').html(res); // Repopulate the specific element with the new content
			},
			error: (error) => {
				console.log({error});
			}
		});
	},

	/**
	 * Add
	 *
	 * @description add an item to `this.data`.
	 *
	 * @param {Object} product
	 *
	 * @returns {void}
	 */
	add(product, value) {
		if (value == '0') {
			this.del(product.id);
			return;
		};

		const cartItem = {
			...product,
			'__cart': value,
		};

		this.data[product.id] = cartItem;
	},

	/**
	 * Delete
	 *
	 * @description delete an item from `this.data`.
	 *
	 * @param {integer} id 
	 *
	 * @returns {void}
	 */
	del(id) {
		const entry = this.data[id];

		if (entry && entry.__cart > 0) {	
			delete this.data[id];
		}
	},

	/**
	 * Clear
	 *
	 * @description clear `this.data`.
	 *
	 * @returns {void}
	 */
	clear() {
		this.data = {};
	},

	/**
	 * Get
	 *
	 * @description fetch a item from `this.data`.
	 *
	 * @param {integer} find
	 *
	 * @returns {integer} quantity
	 */
	get(find) {
		if (!Object.values(this.data)) {
			return 0;
		}

		const item = Object.values(this.data).find(({ id }) => {
			return id === find;
		});

		return item ? item.__cart : 0;
	},

	/**
	 * Computed
	 *
	 * @description computed data based for packaging and totals.
	 *
	 * @returns {object} 
	 */
	get computed() {
		/**
		 * Data values
		 */
		const data = Object.values(this.data);

		/**
		 * Grouped object derived from data
		 */
		const groupedObj = data.reduce((result, item) => {
			const { category } = item;
			const { id } = category;

			result[id] = result[id] || { ...category, entries: [] };
			result[id].entries.push(item);

			return result;
		}, {});

		/**
		 * Grouped data by category
		 */
		const groupedData = Object.values(groupedObj).reduce((result, group) => {
			const {
				slug,
				name,
				fill_cart,
				minimum_plants,
				plants_per_cart,
				plants_per_tray,
				entries
			} = group;

			const plants = entries.reduce((result, item) => {
				const value = this.roundNum(item.__cart);
				return result + value;
			}, 0);
		
			const trays = plants_per_tray ? entries.reduce((result, item) => {
				const value = this.roundNum(item.__cart / plants_per_tray);
				return result + value;
			}, 0) : false;
		
			const carts = plants / plants_per_cart;

			/**
			 * 
			 */
			const validation = { type: 'notice', render: '' };
			const isCartFill = carts === Math.floor(carts);
			const isCartFillRequired = fill_cart && !isCartFill;
			const isCartMinimumOrderRequired = minimum_plants && minimum_plants > plants;

			// error types
			if (isCartFillRequired) {
				validation.type = 'error';
				validation.render = `You must fill a whole cart of ${name}. `;
			}

			if (isCartMinimumOrderRequired) {
				const add = plants_per_tray ? `${(minimum_plants / plants_per_tray) - trays} trays` : `${minimum_plants - plants} plants`;

				validation.type = 'error';
				validation.render = `To reach the minimum order quantity, add ${add}. `;
			}

			// suggestions
			// only show the suggestion if there is a validation error			
			if (!isCartFill && !isCartMinimumOrderRequired && validation?.type === 'error') {
				const offset = (Math.ceil(plants / plants_per_cart) * plants_per_cart) - plants;
				const add = plants_per_tray ? `${offset / plants_per_tray} trays` : `${offset} plants`;

				validation.render = `${validation.render}To fill the cart, add ${add}.`;
			}

			result.push({
				slug,
				name,
				entries,
				plants,
				trays,
				carts,
				cartsRounded: this.roundUpCartNum(carts),
				validation,
			});

			return result;
		}, []);

		/**
		 * Total value of products
		 */
		const total = data.reduce((result, item) => {
			const { price, __cart } = item;
			const value = parseFloat(price) * __cart;
			return result + value;
		}, 0);

		const cartsTotal = groupedData.reduce((result, item) => {
			const { carts } = item;
			return result + carts;
		}, 0);

		return {
			data,
			groupedData,
			total,
			cartsTotal,
		};
	},

	/**
	 * Get Sorted Data
	 *
	 * @description return `this.data` as an sorted array.
	 *
	 * @returns {array}
	 */
	get sortedData() {
		return Object.values(this.data).slice().sort((a, b) => a.name.localeCompare(b.name)) || [];
	},

	/**
	 * Redirect To Pay
	 *
	 * @param {string} url Redirect URL
	 *
	 * @returns {void}
	 */
	redirectToPay(url) {
		/*
		if (this.amountForFreeShipping > this.computed.total) {
			return;
		}
		*/
  
		window.location.href = url;
	},

	/**
	 * Redirect to Pay Button State
	 *
	 * @returns 
	 */
	redirectToPayButtonState() {
		const errors = this.computed.groupedData.reduce((result, group) => {
			if (group.validation.type === 'error') {
				result.push(group.validation);
			}

			return result;
		}, []);

		return errors.length > 0;
	},

	/**
	 * Number to Currency
	 *
	 * @param {string|integer} value
	 * 
	 * @returns {string}
	 */
	numToCurrency(value) {
		return new Intl.NumberFormat("en-US", {
			currency: "USD",
			style: "currency"
		}).format(value);
	},

	/**
	 * Round Number
	 *
	 * @description round float to two decimal points.
	 *
	 * @param value
	 * 
	 * @returns {Number}
	 */
	roundNum(num) {
		return Math.round(num * 100) / 100;
	},

	/**
	 * 
	 */
	roundUpCartNum(num) {
		const roundedNum = Math.ceil(num);
		return num % 1 !== 0 ? `Less than ${roundedNum}` : roundedNum;
	}
});
